import React, { useState } from "react";
import { Link } from "react-router-dom";
import allTeams from "../../data/teams";
import { SolarPower } from "@mui/icons-material";

const TeamMenu = () => {
  const [teams, setTeams] = useState(allTeams || []);
  const [states, setStates] = useState("hide");

  const handleMouseOver = () => {
    setStates("show");
  };

  const handleChangeState = () => {
    states === "hide" ? setStates("show") : setStates("hide");
  };

  const handleMouseOut = () => {
    setStates("hide");
  };

  const divisions = (divisionName: string) => {
    return teams.filter((team) => team.division === divisionName);
  };

  const renderTeamsByDivision = (division: string) => {
    const filteredTeams = teams.filter((team) => team.division === division); // Filter by division
    return filteredTeams.map((team) => (
      <Link to={`/team/${team.rawTricode}`} key={team.id}>
        <div className="teamMenu">
          <div>
            <img
              width={25}
              src={`https://assets.nhle.com/logos/nhl/svg/${team.triCode}_dark.svg`}
              alt={`${team.fullName} logo`}
            />
          </div>
          <div>{team.fullName}</div>
        </div>
      </Link>
    ));
  };

  return (
    <>
      <div className="links">
        <div
          className="TeamMenu"
          onMouseOver={handleMouseOver}
          onClick={handleChangeState}
        >
          <div>Teams</div>
        </div>
      </div>
      <div
        className={`${states} teamWrapper`}
        onClick={handleMouseOut}
        onMouseLeave={handleMouseOut}
      >
        <div className="teamMenuWrapper">
          <div className="divisionMenu">
            <div>
              <h4>Atlantic Division</h4>
            </div>
            <div className="teamList">{renderTeamsByDivision("Atlantic")}</div>
          </div>

          <div className="divisionMenu">
            <div>
              <h4>Metropolitan Division</h4>
            </div>
            <div className="teamList">
              {renderTeamsByDivision("Metropolitan")}
            </div>
          </div>

          <div className="divisionMenu">
            <div>
              <h4>Central Division</h4>
            </div>
            <div className="teamList">{renderTeamsByDivision("Central")}</div>
          </div>

          <div className="divisionMenu">
            <div>
              <h4>Pacific Division</h4>
            </div>
            <div className="teamList">{renderTeamsByDivision("Pacific")}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamMenu;
